function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M9.3,28.6V57H3V28.6H9.3 M12.3,25.6H0V60h12.3V25.6L12.3,25.6z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M25.2,13.2V57h-6.3V13.2H25.2 M28.2,10.2H15.9V60h12.3V10.2L28.2,10.2z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M41.1,33v24h-6.3V33H41.1 M44.1,30H31.8v30h12.3V30L44.1,30z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M57,8.6V57h-6.3V8.6H57 M60,5.6H47.7V60H60V5.6L60,5.6z"
}))))));

var SvgLineGraph = function SvgLineGraph(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/line-graph.644756cd.svg";
export { SvgLineGraph as ReactComponent };